<!-- 智能数据统计 -->
<template>
  <div class="nx-list-page data-statistics-page">
    <matrix-statistics span="8" :list="statisticsCards" :height="cardHeight" />
    <el-card class="chart-card" shadow="never">
      <div class="title">
        <div>
          <el-select v-model="sumType" placeholder="请选择" style="margin-right: 16px;width: 140px;" @change="valueChange">
            <el-option label="日" :value="0"></el-option>
            <el-option label="周" :value="1"></el-option>
            <el-option label="月" :value="2"></el-option>
          </el-select>
          <el-date-picker v-show="sumType == 0" v-model="datePickerTime" v-bind="datePickerProps.day" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>

          <el-date-picker v-show="sumType == 1" v-model="datePickerTime" v-bind="datePickerProps.week" type="month" placeholder="选择月">
          </el-date-picker>

          <el-date-picker v-show="sumType == 2" v-model="datePickerTime" v-bind="datePickerProps.month" type="monthrange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 16px;width: 98px;" @click="getInfo">搜索</el-button>
          <el-button icon="el-icon-refresh-left" style="margin-left: 16px;width: 98px;" @click="searchReset">重置</el-button>
          <!-- <el-button type="success" icon="el-icon-download" style="margin-left: 16px;">导出数据</el-button> -->
        </div>
        <div>
          <!-- <i class="el-icon-time"></i>
          <p> 最后更新：{{ time }} </p> -->
        </div>
      </div>
      <div id="analyse"></div>
    </el-card>
    <div style="height: 24px;"></div>
  </div>
</template>
<script>
import matrixStatistics from '@/components/matrix/matrix-statistics'
import * as echarts from 'echarts';
import moment from "moment";
import { getDate } from '@/util/date.js'
import { getSearchTimeConfig } from '@/basic-common/util/common'
import { getCarInfo, getInfo } from './api';

const toDatePickerProps = (config) => ({
  format: config.format,
  valueFormat: config.valueFormat,
  pickerOptions: config.pickerOptions,
  clearable: config.clearable
})

const DATA_STATISTICS_DATE_PICKER_PROPS = {
  day: toDatePickerProps(getSearchTimeConfig([], { type: 'daterange' })),
  week: toDatePickerProps(getSearchTimeConfig([], {
    type: 'month',
    format: 'yyyy 年 MM 月',
    valueFormat: 'yyyy-MM'
  })),
  month: toDatePickerProps(getSearchTimeConfig([], { type: 'monthrange' }))
}

const getMonthEndDate = (month) => moment(`${month}-01`).endOf('month').format('YYYY-MM-DD')

const getRecentSixMonthRange = () => [
  moment().subtract(5, 'months').format('YYYY-MM'),
  moment().format('YYYY-MM')
]

export default {
  name: "data-statistics",
  components: {
    matrixStatistics
  },
  data () {
    return {
      form: {},
      sumType: 0,
      datePickerTime: null,
      datePickerProps: DATA_STATISTICS_DATE_PICKER_PROPS,
      time: '',
      /** 顶部 KPI 卡片高度，略增高以容纳环比一行 */
      cardHeight: '132px'
    };
  },
  computed: {
    statisticsCards () {
      const f = this.form || {}
      const pct = (v) => {
        const n = Number(v)
        if (v == null || v === '' || Number.isNaN(n)) return '0.00'
        return Math.abs(n).toFixed(2)
      }
      const cmp = (v) => {
        const n = Number(v)
        if (v == null || v === '' || Number.isNaN(n) || n === 0) return null
        return n > 0 ? 1 : 0
      }
      const cmpColor = (v) => {
        const n = Number(v)
        if (v == null || v === '' || Number.isNaN(n) || n === 0) return '#94a3b8'
        return n > 0 ? '#22C55E' : '#EF4444'
      }
      return [
        {
          label: '日发运量',
          value: f.todayWeight != null && f.todayWeight !== '' ? f.todayWeight : 0,
          unit: ' 吨',
          subhead: `${pct(f.dayGrowthPercentage)}%`,
          compare: cmp(f.dayGrowthPercentage),
          compareColor: cmpColor(f.dayGrowthPercentage),
          tip: '较昨日',
          icon: 'el-icon-s-promotion',
          iconColor: '#3B82F6'
        },
        {
          label: '周发运量',
          value: f.thisWeekWeight != null && f.thisWeekWeight !== '' ? f.thisWeekWeight : 0,
          unit: ' 吨',
          subhead: `${pct(f.weekGrowthPercentage)}%`,
          compare: cmp(f.weekGrowthPercentage),
          compareColor: cmpColor(f.weekGrowthPercentage),
          tip: '较上周',
          icon: 'el-icon-s-marketing',
          iconColor: '#3B82F6'
        },
        {
          label: '月发运量',
          value: f.thisMonthWeight != null && f.thisMonthWeight !== '' ? f.thisMonthWeight : 0,
          unit: ' 吨',
          subhead: `${pct(f.monthGrowthPercentage)}%`,
          compare: cmp(f.monthGrowthPercentage),
          compareColor: cmpColor(f.monthGrowthPercentage),
          tip: '较上月',
          icon: 'el-icon-s-data',
          iconColor: '#3B82F6'
        }
      ]
    }
  },
  created () {
    this.getTime()
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    // 获取详情
    getInfo () {
      if (!this.hasSearchTimeValue()) {
        return this.$message({
          message: '请选择您要查询的时间或日期',
          type: 'warning'
        });
      }
      this.time = getDate()
      const { startTime, endTime } = this.getSearchTimeRange()
      getCarInfo({
        dayDate: getDate('now', { format: 'YYYY-MM-DD' })
      }).then(res => {
        this.form = res.data.data
      })
      getInfo({
        startTime,
        endTime,
        sumType: this.sumType,
        businessType: 1
      }).then(res => {
        const chartData = this.normalizeTrendData(res.data.data)
        if (chartData.length == 0) {
          this.$message({
            message: '未查询到数据！',
            type: 'warning'
          });
        }
        this.analyseInit(chartData)
      })
    },
    hasSearchTimeValue () {
      if (Array.isArray(this.datePickerTime)) {
        return this.datePickerTime.length === 2 && this.datePickerTime.every(Boolean)
      }
      return !!this.datePickerTime
    },
    getSearchTimeRange () {
      const _val = this.datePickerTime
      if (this.sumType == 0) {
        return {
          startTime: _val[0],
          endTime: _val[1]
        }
      }
      if (this.sumType == 1) {
        const startMonth = moment(`${_val}-01`)
        const endMonth = moment(getMonthEndDate(_val))
        return {
          startTime: startMonth.startOf('isoWeek').format('YYYY-MM-DD'),
          endTime: endMonth.endOf('isoWeek').format('YYYY-MM-DD')
        }
      }
      return {
        startTime: `${_val[0]}-01`,
        endTime: getMonthEndDate(_val[1])
      }
    },
    normalizeTrendData (data) {
      if (this.sumType != 2) {
        return Array.isArray(data) ? data : []
      }
      const [startMonth, endMonth] = this.datePickerTime || []
      if (!startMonth || !endMonth) {
        return Array.isArray(data) ? data : []
      }
      const dataMap = (Array.isArray(data) ? data : []).reduce((map, item) => {
        map[item.axisValue] = item
        return map
      }, {})
      const result = []
      const cursor = moment(`${startMonth}-01`)
      const end = moment(`${endMonth}-01`)
      while (cursor.isSameOrBefore(end, 'month')) {
        const axisValue = cursor.format('YYYY-MM')
        result.push(dataMap[axisValue] || {
          axisValue,
          weightSum: 0
        })
        cursor.add(1, 'month')
      }
      return result
    },
    // 获取图表
    analyseInit (data) {
      let chartDom = document.getElementById('analyse');
      let myChart = echarts.init(chartDom);
      let xAxis = data.map(res => {
        return res.axisValue
      })
      let series = data.map(res => {
        return res.weightSum
      })
      let name = ['日发运量', '周发运量', '月发运量']
      let color = ['#10b981', '#2563eb', '#6e7079']
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          show: true,
          textStyle: {
            color: '#374151',
            fontSize: 14,
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis,
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          }
        },
        series: [
          {
            name: name[this.sumType],
            data: series,
            type: 'line',
            smooth: true,
            lineStyle: {
              color: color[this.sumType],
              width: 2,
            },
            itemStyle: {
              color: color[this.sumType],
            },
          }

        ]
      };
      myChart.clear()
      option && myChart.setOption(option);
    },

    // 重置
    searchReset () {
      this.getTime()
      this.getInfo()
    },
    // 获取默认时间
    getTime () {
      this.sumType = 2
      this.datePickerTime = getRecentSixMonthRange()
    },
    // 切换时间类型
    valueChange () {
      if (this.sumType == 0 || this.sumType == 2) {
        this.datePickerTime = []
      } else {
        this.datePickerTime = moment().format('YYYY-MM')
      }
    }
  }
};
</script>
<style scoped lang="scss">
.data-statistics-page {
  min-width: 0;
}

.chart-card {
  border-radius: 8px;
}

#analyse {
  width: 100%;
  height: 400px;
  margin-top: 20px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;

    p {
      font-size: 14px;
      color: #6b7280;
      margin-left: 10px;
    }
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
